import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getVideosByCategory } from "@/utils/video";

const accentMap: Record<string, { bg: string; text: string }> = {
  primary: { bg: "bg-primary-100", text: "text-primary-600" },
  accent: { bg: "bg-accent-100", text: "text-accent-700" },
  secondary: { bg: "bg-secondary-100", text: "text-secondary-600" },
};

export default function CategoryQuick() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
      {categories.map((c, i) => {
        const accent = accentMap[c.accent] ?? accentMap.primary;
        const count = getVideosByCategory(c.id).length;
        return (
          <Link
            key={c.id}
            to={`/category/${c.id}`}
            className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 hover:border-primary-300 hover:bg-primary-50/60 cursor-pointer transition-colors animate-fadeUp"
            style={{ animationDelay: `${i * 60}ms` }}
          >
            <span className={`flex items-center justify-center w-11 h-11 rounded-lg ${accent.bg} ${accent.text}`}>
              <i className={`${c.icon} text-2xl`} />
            </span>
            <h3 className="mt-3 text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
              {c.name}
            </h3>
            <p className="mt-1 text-xs text-foreground-500">{count} 部内容 · 高清免费</p>
            <i className="ri-arrow-right-s-line absolute top-4 right-3 text-foreground-300 group-hover:text-primary-500 transition-colors" />
          </Link>
        );
      })}
    </div>
  );
}